import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassingNotificationComponent } from './passing-notification/passing-notification';

@Component({
  selector: 'app-report-passing',
  standalone: true,
  imports: [
    CommonModule,
    PassingNotificationComponent
  ],
  templateUrl: './report-passing.html',
  styleUrls: ['./report-passing.css']
})
export class ReportPassingComponent {}